// extracted by mini-css-extract-plugin
module.exports = {"button":"src-components-ButtonWithText-styles__button--2a2ER","icon":"src-components-ButtonWithText-styles__icon--1TEEF"};